(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["listing-shuffle"] && !Shopify.designMode) return;
  try {
    const listingSelector = '[data-listing-shuffle]';
  const processedListings = new WeakMap();

  function listingRank(value) {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) {
      hash = Math.imul(hash ^ value.charCodeAt(index), 16777619);
    }
    hash ^= hash >>> 16;
    hash = Math.imul(hash, 0x85ebca6b);
    hash ^= hash >>> 13;
    return hash >>> 0;
  }

  function mixStockGroup(entries) {
    const groups = new Map();
    entries.forEach(entry => {
      if (!entry.fixed) {
        if (!groups.has(entry.product)) groups.set(entry.product, []);
        groups.get(entry.product).push(entry);
      }
    });
    groups.forEach(group => group.sort((a, b) => a.rank - b.rank));

    let previousProduct = '';
    return entries.map(entry => {
      if (entry.fixed) {
        previousProduct = entry.product;
        return entry.element;
      }
      const remaining = Array.from(groups.entries()).filter(([, cards]) => cards.length);
      const alternatives = remaining.filter(([product]) => product !== previousProduct);
      const choices = alternatives.length ? alternatives : remaining;
      const countAfter = remaining.reduce((count, [, cards]) => count + cards.length, 0) - 1;
      const feasible = choices.filter(([chosen]) => remaining.every(([product, cards]) =>
        cards.length - (product === chosen ? 1 : 0) <=
        (product === chosen ? Math.floor(countAfter / 2) : Math.ceil(countAfter / 2))));
      const candidates = feasible.length ? feasible : choices;
      candidates.sort((a, b) => (feasible.length ? 0 : b[1].length - a[1].length) || a[1][0].rank - b[1][0].rank);
      const selected = candidates[0][1].shift();
      previousProduct = selected.product;
      return selected.element;
    });
  }

  function mixListing(grid) {
    const shouldMix = ['', 'manual', 'relevance'].includes(grid.dataset.listingSort || '');
    const children = Array.from(grid.children);
    const seed = `weavers-listing-mix-20260915:${grid.dataset.listingShuffle}`;
    const entries = children.map(element => {
      const card = element.querySelector('[data-listing-product]');
      return {
        element,
        isProduct: Boolean(card),
        available: card?.dataset.listingAvailable !== 'false',
        fixed: !card || card.hasAttribute('data-listing-fixed'),
        product: card?.dataset.listingProduct || '',
        rank: listingRank(`${seed}:${card?.dataset.listingCard || ''}`)
      };
    });
    const previous = processedListings.get(grid);
    if (previous && previous.sort === grid.dataset.listingSort && entries.length === previous.cards.size &&
      entries.every(entry => previous.cards.get(entry.element) === entry.available)) return;
    processedListings.set(grid, {
      sort: grid.dataset.listingSort,
      cards: new Map(entries.map(entry => [entry.element, entry.available]))
    });

    const available = entries.filter(entry => entry.isProduct && entry.available);
    const soldOut = entries.filter(entry => entry.isProduct && !entry.available);
    const orderGroup = group => shouldMix ? mixStockGroup(group) : group.map(entry => entry.element);
    const products = [...orderGroup(available), ...orderGroup(soldOut)];
    let productIndex = 0;
    const ordered = entries.map(entry => entry.isProduct ? products[productIndex++] : entry.element);

    if (ordered.every((element, index) => element === children[index])) return;
    ordered.forEach((element, index) => {
      if (grid.children[index] !== element) grid.insertBefore(element, grid.children[index] || null);
    });
    Array.from(grid.children).slice(0, 6).forEach(element => {
      const image = element.querySelector('img');
      if (image) image.loading = 'eager';
    });
    const slider = grid.closest('slider-component');
    if (slider?.nextButton && typeof slider.resetPages === 'function') slider.resetPages();
  }

  function collectListings(element, listings) {
    if (!(element instanceof Element)) return;
    const parentListing = element.closest(listingSelector);
    if (parentListing) listings.add(parentListing);
    element.querySelectorAll(listingSelector).forEach(grid => listings.add(grid));
  }

  function startListingMix() {
    document.querySelectorAll(listingSelector).forEach(mixListing);
    const observer = new MutationObserver(records => {
      const listings = new Set();
      records.forEach(record => {
        collectListings(record.target, listings);
        record.addedNodes.forEach(node => collectListings(node, listings));
      });
      listings.forEach(grid => {
        if (grid.isConnected) mixListing(grid);
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-listing-available']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startListingMix, { once: true });
  } else {
    startListingMix();
  }
  } catch(e) { console.error(e); }
})();

})();
